import Vue from 'vue'
import router from '@/router'
import store from '@/store/store'
import { KONTUR_METRIKA_URL } from '@/common/config'

function loadScript(callback) {
  const script = document.createElement('script')
  script.async = true
  script.src = KONTUR_METRIKA_URL

  document.head.appendChild(script)
  script.onload = callback
}

function createTracker() {
  Vue.prototype.$km_track = Vue.$km_track = trackEvent
}

function trackEvent(category, action, label, customValues) {
  const tracker = window['market_tipsTracker']
  if (process.env.NODE_ENV !== 'production') {
    tracker.enableDevMode()
  }
  const { currentUser, currentBranch } = store.getters
  const commonValues = {
    userid: currentUser.id,
    branchid: currentBranch.id
  }

  try {
    const cv = {
      ...customValues,
      ...commonValues
    }
    tracker.trackEvent(category, action, label, cv)
  } catch (error) {
    console.error('[Kontur.Metrika]', error)
  }
}

function startRouterTracking() {
  router.afterEach((to, from) => {
    if (to.path === from.path) {
      return
    }

    Vue.nextTick(() => {
      const { currentBranch, currentUser } = store.getters
      const customValues = {
        branchid: currentBranch.id
      }
      const userRole = currentUser.userRole !== undefined ? currentUser.userRole : ''
      const category = `${userRole}Menu`
      const label = to.name || document.title

      Vue.$km_track(category, 'Click', label, customValues)
    })
  })
}

export default function install() {
  loadScript(() => {
    createTracker()
    startRouterTracking()
  })
}
